import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {KeyboardArrowLeft} from "../../../icons/keyboard-arrow/keyboard-arrow-left";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

export class CarouselArrowProps extends BaseProps {
  isPrev: Boolean = false;
  label: String;
  onClick: Function;
  shouldCenterArrow: Boolean;
}

export const CarouselArrowSmall = (props: CarouselArrowProps) => {
  const containerProps = {
    className: classNames(styles.arrow_container, props.className, {
      [styles.arrow_container_prev]: props.isPrev,
      [styles.arrow_container_next]: !props.isPrev
    }),
    onClick: () => props.onClick()
  };

  const arrowProps = {
    className: classNames(styles.arrow, props.className,
      {
        [styles.arrow_prev]: props.isPrev,
        [styles.arrow_next]: !props.isPrev
      }),
  };

  return (
    <div {...containerProps}>
      <KeyboardArrowLeft {...arrowProps}/>
      {
        props.label
      }
    </div>
  )
};
